import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

const MenuCard = ({
  title,
  titleLink,
  cardBody,
  primaryButton,
  secondaryButton,
  tertiaryButton,
}: {
  title?: string;
  titleLink?: string;
  cardBody?: ReactNode;
  primaryButton?: ReactNode;
  secondaryButton?: ReactNode;
  tertiaryButton?: ReactNode;
}) => {
  const renderTitle = () => {
    const titleElement = (
      <Typography variant="headlineMedium">{title}</Typography>
    );
    if (titleLink) {
      return (
        <Link to={titleLink}>
          <Box sx={{ color: "primary.main", textDecoration: "underline" }}>
            {titleElement}
          </Box>
        </Link>
      );
    }
    return titleElement;
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "surface.main",
        rowGap: 2,
        p: 2,
      }}
      variant="outlined"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: {
            xs: cardBody ? "column" : "row",
            sm: "row",
          },
          columnGap: 4,
          rowGap: 2,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
          {renderTitle()}
          {cardBody}
        </Box>
        {(primaryButton || secondaryButton || tertiaryButton) && (
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: cardBody ? "row" : "column",
                sm: "column",
              },
              rowGap: 2,
              columnGap: 1,
              alignItems: "end",
              justifyContent: {
                xs: cardBody ? "end" : "start",
                sm: "start",
              },
              flexShrink: 0,
              mt: "2px",
            }}
          >
            {primaryButton && <Box>{primaryButton}</Box>}
            {secondaryButton && <Box>{secondaryButton}</Box>}
            {tertiaryButton && <Box>{tertiaryButton}</Box>}
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default MenuCard;
